module.exports = __webpack_public_path__ + "img/light_2.96776475.png";